document.addEventListener('DOMContentLoaded', function () {
  // Sticky header solid state
  var header = document.querySelector('.pb-header');
  if (header && !header.hasAttribute('data-pb-solid-default')) {
    function onScroll() {
      if (window.scrollY > 60) header.classList.add('pb-solid');
      else header.classList.remove('pb-solid');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu
  var burger = document.getElementById('pbBurger');
  var menu = document.getElementById('pbMobileMenu');
  var closeBtn = document.getElementById('pbMobileClose');
  if (burger && menu) {
    burger.addEventListener('click', function () { menu.classList.add('pb-open'); });
    if (closeBtn) closeBtn.addEventListener('click', function () { menu.classList.remove('pb-open'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('pb-open'); });
    });
  }

  // Reveal on scroll
  var revealEls = document.querySelectorAll('[data-pb-reveal]');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('pb-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('pb-in'); });
    }
  }

  // Simple variant -> price/image sync for the Offer section (single product, select-based)
  document.querySelectorAll('[data-pb-offer]').forEach(function (form) {
    var select = form.querySelector('[data-pb-variant-select]');
    var priceEl = form.querySelector('[data-pb-price]');
    var compareEl = form.querySelector('[data-pb-compare]');
    if (!select) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        if (opt.dataset.compare && opt.dataset.compare !== opt.dataset.price) {
          compareEl.textContent = opt.dataset.compare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    });
  });
});
